export default __webpack_public_path__ + "static/media/volunteer.9805f331.svg";